export const SUBMISSIONS_RESET = 'SUBMISSIONS_RESET';
export const SUBMISSIONS_REQUEST = 'SUBMISSIONS_REQUEST';
export const SUBMISSIONS_SUCCESS = 'SUBMISSIONS_SUCCESS';
export const SUBMISSIONS_FAILURE = 'SUBMISSIONS_FAILURE';
